import Tile from 'ol/layer/tile'
import LayerVector from 'ol/layer/vector'
import SourceTileWMS from 'ol/source/tilewms'
import SourceVector from 'ol/source/vector'

import style from './style'

import config from '@/config'

const geoserverURL = `${config.geoserver.geoserverURL}/${config.geoserver.geoserverWorkspace}/wms`

export const LayerOrto = new Tile({
  name: 'Ortofoto',
  source: new SourceTileWMS({
    crossOrigin: 'anonymous',
  })
})

export const LayerRaster = new Tile({
  name: 'Ráster',
  opacity: 0.5,
  source: new SourceTileWMS({
    crossOrigin: 'anonymous',
  })
})

export const LayerDraw = new LayerVector({
  source: new SourceVector(),
  style
})

export const LayerActuacion = new Tile({
  name: 'Actuación',
  source: new SourceTileWMS({
    url: geoserverURL,
    crossOrigin: 'anonymous',
    params: {
      // layers: 'actuacion'
    }
  })
})


// WEBPACK FOOTER //
// ./src/components/core/utils/layers.js